/**
 * /me/loans/apply — Session 3d PR 13.
 * Owning agent: Khidmat. Detail-card-style page (NOT a list).
 */

import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";

import { ErrorPanel, Loading } from "../components/Loading";
import { session3dApi } from "../lib/session3d-api";
import {
  MeActionsRow,
  MeEmployeeRequiredGate,
  Session3dMeShell,
  useCurrentEmployeeId,
} from "./_session3dShell";

export function MyApplyLoanPage() {
  const { t } = useTranslation();
  const employeeId = useCurrentEmployeeId();

  const query = useQuery({
    queryKey: ["s3d-apply-loan", employeeId],
    queryFn: () => session3dApi.listMyLoanApplications(employeeId),
    enabled: !!employeeId,
  });

  const data = query.data;

  return (
    <MeEmployeeRequiredGate>
      <Session3dMeShell
        title={t("me.apply-loan.title", "Apply for a Loan")}
        subtitle={t("me.apply-loan.subtitle", "Eligibility-checked loan application. Khidmat narrates eligibility upfront.")}
        briefContext={{
          total: 1,
          attention: 0,
          critical: 0,
          top_kind: t("me.apply-loan.title", "Apply for a Loan"),
          window_label: t("me.apply-loan.window", "your eligible products"),
        }}
        actionsRow={
          <MeActionsRow
            khidmatPrefill={t("me.apply-loan.ask_khidmat", "Am I eligible for a personal loan?")}
          />
        }
      >
        {query.isLoading && <Loading />}
        {query.isError && <ErrorPanel message={(query.error as Error).message} />}
        {data && (
          <div className="rounded-2xl border border-border-subtle bg-white p-4 text-sm">
            <p className="text-xs text-text-tertiary">
              {t(
                "me.apply-loan.detail_note",
                "4-step wizard: product picker (eligibility-filtered) → amount + tenure (with Article 90 cap watch) → reason + docs → preview + submit. The wizard drawer wires with M3X.LOANS pack.",
              )}
            </p>
            <pre className="mt-3 overflow-x-auto rounded bg-surface-sunken p-3 font-mono text-[10px] text-text-secondary">
{JSON.stringify(data, null, 2)}
            </pre>
          </div>
        )}
      </Session3dMeShell>
    </MeEmployeeRequiredGate>
  );
}
